import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
 
import Home from './components/Home';
import About from './components/About';
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';
import Radio from './components/Radio';
import Doublage from './components/Doublage';
import Musique from './components/Musique';
import Error from './components/Error';
import Navigation from './components/Navigation';

import './css/App.css';
import './css/video-react.css';
 
class App extends Component {
  render() {
    return (      
       <BrowserRouter>
        <div className="App">
          <Navigation />
            <Switch>
             <Route path="/" component={Home} exact/>
             <Route path="/about" component={About}/>
             <Route path="/portfolio" component={Portfolio}/>
             <Route path="/contact" component={Contact}/>
             <Route path="/radio" component={Radio}/>
             <Route path="/doublage" component={Doublage}/>
             <Route path="/musique" component={Musique}/>
             <Route component={Error}/>
           </Switch>
        </div> 
      </BrowserRouter>
    );
  }
}
 
export default App;
